import { DownloadOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Select, Space } from 'antd';
import { EChartsOption } from 'echarts-for-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { exportCSV } from '@/infrastructure/export-csv';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { ButtonWithLoading } from '@/presentation/components/button-with-loading';
import { MetricType } from '@/proto/metric';
import { PROPORTION_UNIT_OPTIONS, ProportionEnum } from '../trend-analysis/config';
import styles from './index.module.scss';

interface IProps {
  pgId: string;
  pgName: string;
  option: EChartsOption;
  disabled: boolean;
  title?: string;
  isHiddenCompare?: boolean
  metricType?: MetricType;
  addToCompareList?: () => void;
  className?: string;
  editable?: boolean;
  unitEditEnable?: boolean;
  onProportionChange?: (unit: ProportionEnum) => void;
}

export const ChartTools = (props: IProps) => {
  const { t } = useTranslation();
  const { pgId, pgName, metricType, option, addToCompareList, disabled, className, title, unitEditEnable } = props;
  const [proportionUnit, setProportionUnit] = useState(ProportionEnum.Hundred);

  const onAddToCompareList = () => {
    addToCompareList?.();
    metricType && reportClick(pgId, CUSTOM_ACTIONS.quotaAddToCompList, { from: pgId, param1: metricType });
  };

  const onDownloadCSV = async () => {
    const timestamp = option.xAxis.data;
    const data: { name: string; unit: string; data: [] }[] = option.series;
    const head = [[t('时间范围'), ...data.map(item => `${item.name}${item.unit ? `（${item.unit}）` : ''}`)]];
    const body = [];
    for (let i = 0; i < timestamp.length; i++) {
      body.push([
        timestamp[i],
        ...data.map(item => `${item.data?.[i] ?? '--'}`),
      ]);
    }
    await exportCSV(pgName, head, body);
  };

  const onUnitChange = (unit: ProportionEnum) => {
    setProportionUnit(unit);
    props.onProportionChange?.(unit);
  };

  return <div
    className={className}
    style={{
      display: 'flex',
      justifyContent: 'space-between',
    }}>
    <Space>
      {<span className={styles.cardTitle}>{title ? title : ''}</span>}
      {unitEditEnable && <Select onChange={onUnitChange}
      options={PROPORTION_UNIT_OPTIONS} style={{ width: 120 }} value={proportionUnit} />}
    </Space>
    <Space size={16}>
      { !props.isHiddenCompare ? <Button
        icon={<PlusOutlined />}
        onClick={onAddToCompareList}
        disabled={disabled}
      >
        {t('加入对比列表')}
      </Button> : null
      }
      <ButtonWithLoading
        icon={<DownloadOutlined />}
        onClick={onDownloadCSV}
        disabled={disabled}
      />
    </Space>
  </div>;
};
